import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TextInputWrapper = styled(Box)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: theme.spacing(2),
  },
}));
